import { connect } from "react-redux"

import { selectSelectedLanguage } from "redux/reducers/ui/config"

const mapStateToProps = () => state => ({
    currentLanguage: selectSelectedLanguage(state),
})

export default connect(mapStateToProps, null)
